module.exports = __webpack_public_path__ + "img/icon_do_police@2x.8796fcd1.png";